const FIELDS = [
  "token",
  "id",
  "username",
  "email",
  "role_id",
  "role_name",
  "company_id",
  "company_type",
  "region_id",
  "industry_type_id",
  "full_name",
  "profile_pic",
  "company_detail",
  "subscription_package",
  "is_social_login",
  "impersonation",
  "impersonated_by",
];

function consumeImpersonationHash() {
  const hash = window.location.hash || "";
  const marker = "#impersonate=";
  if (hash.indexOf(marker) !== 0) return;

  try {
    const data = JSON.parse(decodeURIComponent(hash.slice(marker.length)));
    if (!data || !data.token) return;

    const session = { impersonation: true };
    FIELDS.forEach((field) => {
      if (Object.prototype.hasOwnProperty.call(data, field)) {
        session[field] = data[field];
      }
    });

    // Same keys as Login.js proceedWithLogin
    localStorage.setItem("authToken", session.token);
    localStorage.setItem("lastActivity", Date.now().toString());
    localStorage.setItem("userData", JSON.stringify(session));
    localStorage.setItem("userFullName", session.full_name || "");
    localStorage.setItem("userProfilePic", session.profile_pic || "");
  } catch (error) {
    console.error("Unable to start impersonation session:", error);
  } finally {
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search
    );
  }
}

consumeImpersonationHash();
